module.exports = __webpack_public_path__ + "img/european-left-logo.9478b2a0.svg";